export const statsBuffer = {
    value: null,
    addProjectionMetrics: null,
};
//# sourceMappingURL=buffer.js.map